import { createContext } from "react";

export const AppContext = createContext({
  extensionId: undefined,
  resetToken: undefined,
  confirmationCode: undefined,
});
